import React from 'react';

export default function Card({ children }) {
    return (
        <div className="card-header flex-wrap py-5">
            {children}
        </div>
    )
}